

export const CHECK_YEAR = {
    "1": '一年',
    '2': '二年',
    '3':'三年',
    '4':'四年',
    '5':'五年',
}